export class MoneyCalculator {
  constructor(exchangeRate) {
    this.exchangeRate = exchangeRate;
  }

  static handleDecimal(price, currency) {
    if (currency !== "USD") return String(Math.round(price));
    if (!String(price).includes(".")) return String(price);
    return (Math.round(price * 100) / 100).toFixed(2);
  }

  static addThousandsComma(num) {
    let parts = String(num).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  static addCurrencySymbol(price, currency) {
    if (isNaN(Number(price))) return 0;
    const currencySymbol = {
      TWD: "$",
      USD: "$",
      CNY: "¥"
    };
    const formattedPrice = MoneyCalculator.addThousandsComma(
      MoneyCalculator.handleDecimal(Number(price), currency)
    );
    return `${currencySymbol[currency]}${formattedPrice} ${currency}`;
  }

  static isCurrencyMultiple(currencies) {
    const removeRepeat = new Set(currencies);
    return removeRepeat.size > 1;
  }

  static getMainCurrency(currencies) {
    if (currencies.includes("TWD")) return "TWD";
    if (currencies.includes("USD")) return "USD";
    return "CNY";
  }

  convertPriceByCurrency(price, fromCurrency, toCurrency) {
    if (price === 0 || !fromCurrency || !toCurrency) return 0;
    return this.constructor.handleDecimal(
      (price * this.exchangeRate[fromCurrency].TWD) / this.exchangeRate[toCurrency].TWD,
      toCurrency
    );
  }

  // @priceWithCurrencies: [{ price: number, currency: string }]
  calculationPriceWithCurrency(priceWithCurrencies, defaultMainCurrency) {
    if (priceWithCurrencies.length === 0) return 0;
    const mainCurrency = defaultMainCurrency || this.constructor.getMainCurrency(
      priceWithCurrencies.map(
        priceWithCurrency => priceWithCurrency.currency
      )
    );
    const prices = priceWithCurrencies.map(({ price, currency }) =>
      Number(this.convertPriceByCurrency(price, currency, mainCurrency))
    );
    const total = prices.reduce((accumulator, currentValue) => (
      accumulator + currentValue
    ), 0);
    return total;
  }
}